import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';

interface SubmitButtonProps {
    label: string;
    isLoading: boolean;
    onClick: () => void;
    buttonClassName: string;
    disabledClassName: string;
    labelClassName: string;
    rowClassName: string;
}

export const SubmitButton = ({
    label,
    isLoading,
    onClick,
    buttonClassName,
    disabledClassName,
    labelClassName,
    rowClassName,
}: SubmitButtonProps) => (
    <Grid className={rowClassName}>
        <Button
            color="primary"
            variant="contained"
            size="large"
            classes={{ root: buttonClassName, disabled: disabledClassName }}
            type="button"
            onClick={onClick}
            data-dd-privacy="allow"
            automation-id="imago-id-login-button"
            disabled={isLoading}
        >
            {isLoading ? (
                <CircularProgress size={20} />
            ) : (
                <Typography color="inherit" variant="body2" classes={{ root: labelClassName }}>
                    {label}
                </Typography>
            )}
        </Button>
    </Grid>
);
